import { render, staticRenderFns } from "./ShiftManage.vue?vue&type=template&id=51ddb864&scoped=true&"
import script from "./ShiftManage.vue?vue&type=script&lang=js&"
export * from "./ShiftManage.vue?vue&type=script&lang=js&"
import style0 from "./ShiftManage.vue?vue&type=style&index=0&id=51ddb864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ddb864",
  null
  
)

export default component.exports